import {BaseEntity, BaseEntityNameLess} from "./BaseEntity";
import {
    EvPreset,
    MaasPreset,
    PopulationPreset,
    PublicTransitPresetEntity,
    RoadInfrastructurePresetEntity, ScenarioCasePreset
} from "./replancity_PublicTransitPreset";

export const enum RunState {
    NEVER = 'NEVER',
    IN_PROGRESS = 'IN_PROGRESS',
    TERMINATING = 'TERMINATING',
    COMPLETE = 'COMPLETE',
    ERROR = 'ERROR',
    OUTDATED = 'OUTDATED',
    CANCELED = 'CANCELED',
    POSTANALYSIS = 'POSTANALYSIS'
}

export type RunTaskEntity = {
    config: any;
    jobId: number;
    maxIteration: number;
    population: PopulationPreset;
    publicTransit: PublicTransitPresetEntity;
    roadPreset: RoadInfrastructurePresetEntity;
    maasPreset: MaasPreset;
    evPreset: EvPreset;
    scenarioCasePreset: ScenarioCasePreset;
    quality: number;
    relaxationStartOnPercentage: number;
    simulationProgress: number;
    state: RunState;
    stopType: "DYNAMIC" | "FIXED";
    updateTs: string;
    useTransit: boolean;
    version: number;
} & BaseEntity;